import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { sensitivity: { type: Number, default: 1.5 } }

  connect() {
    this.isDragging = false
    this.startX = 0
    this.scrollLeft = 0
    this.pointerId = null
  }

  pointerDown(event) {
    if (event.target.closest(".task-card, .list-handle, button, a, input, textarea")) return

    this.isDragging = true
    this.pointerId = event.pointerId
    this.startX = event.pageX - this.element.offsetLeft
    this.scrollLeft = this.element.scrollLeft
    this.element.classList.add("kanban-scroll-dragging")
    this.element.setPointerCapture(event.pointerId)
  }

  pointerMove(event) {
    if (!this.isDragging || event.pointerId !== this.pointerId) return

    event.preventDefault()
    const x = event.pageX - this.element.offsetLeft
    const walk = (x - this.startX) * this.sensitivityValue
    this.element.scrollLeft = this.scrollLeft - walk
  }

  pointerUp(event) {
    if (event.pointerId !== this.pointerId) return

    this.isDragging = false
    this.element.classList.remove("kanban-scroll-dragging")
    if (this.element.hasPointerCapture(event.pointerId)) {
      this.element.releasePointerCapture(event.pointerId)
    }
  }
}
